import React from 'react'
import { Link } from '@inertiajs/react'
import { Box, Typography } from '@mui/material'

interface Props {
  size?: 'sm' | 'md' | 'lg'
  href?: string
}

const sizes = {
  sm: { font: '1.4rem', dot: 8 },
  md: { font: '1.9rem', dot: 10 },
  lg: { font: '2.4rem', dot: 12 },
}

export default function BrandLogo({ size = 'md', href = '/' }: Props) {
  const s = sizes[size]
  return (
    <Box
      component={Link}
      href={href}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        textDecoration: 'none',
        color: 'primary.main',
      }}
    >
      <Typography
        component="span"
        sx={{
          fontFamily: '"Pacifico", "Brush Script MT", cursive',
          fontSize: s.font,
          color: 'primary.main',
          lineHeight: 1,
        }}
      >
        KpopMap
      </Typography>
      <Box
        component="span"
        aria-hidden
        sx={{
          width: s.dot,
          height: s.dot,
          borderRadius: '50%',
          backgroundColor: 'primary.main',
          opacity: 0.85,
          mt: '-0.6em',
        }}
      />
    </Box>
  )
}
